module.exports = {"id":"188268","name":"Lautaro Acosta","rating":"78","photo":"./data/images/photos/1/188268.png","club":{"name":"Lanús","logo":"./data/images/clubs/Lanus.png"},"positions":["AG","AD","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LautaroAcosta0.json
// module id = 2444
// module chunks = 0